export const SITE = {
  name: 'FoxInmo',
  shortName: 'FoxInmo',
  defaultOgImage: '/og-foxinmo.png',
  icon: '/foxinmo-icon.svg',
  area: 'Tucumán, Argentina',
  team: [
    { name: 'Facundo Décima', bioKey: 'aboutCardOne' },
    { name: 'Alejandro Torres', bioKey: 'aboutCardTwo' },
  ],
  // Used only if /api/meta/owner is unreachable; values mirror backend/.env.example.
  fallbackContact: {
    ownerPhone: '3816232549',
    ownerEmail: 'foxsoftware0@gmail.com',
    ownerWhatsapp: '5493816232549',
  },
};

export const STORAGE_KEYS = {
  language: ['foxinmo_language', 'decima_language'],
  theme: ['foxinmo_theme', 'decima_theme'],
  adminUser: ['foxinmo_admin_user', 'decima_admin_user'],
  adminPass: ['foxinmo_admin_pass', 'decima_admin_pass'],
};

export function readStored([key, legacyKey]) {
  try {
    return localStorage.getItem(key) ?? (legacyKey ? localStorage.getItem(legacyKey) : null);
  } catch (_error) {
    return null;
  }
}

export function writeStored([key, legacyKey], value) {
  try {
    if (value == null) {
      localStorage.removeItem(key);
    } else {
      localStorage.setItem(key, value);
    }
    if (legacyKey) {
      localStorage.removeItem(legacyKey);
    }
  } catch (_error) {
    // Storage can be unavailable (private mode); preferences simply won't persist.
  }
}
